import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { Box, Button } from "@mui/material";
import protec_logo_white from "../../src/components/NavBar/logo_white_red.png";
import protec_background from "../protec_tlo.webp";
import LoginIcon from '@mui/icons-material/Login';
export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch((e) => {
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e) => {
      });
    }
  };
  return (
    <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center",
      background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(' "  + protec_background+"')",  

    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "50px 100px",
        border: "1px solid #ddd",
        borderRadius: "12px",
        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)", 
        background: "rgba(51, 51, 51, 0.9)", 
      }}
    >
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        
        <img
          src={protec_logo_white}  
          alt="Logo"
          style={{ width: "100px", height: "auto" }}
        />
      </div>
      <Button
        endIcon={<LoginIcon/>}
        style={{
          padding: "13px 50px",
          background: "white",
          color: "black",
          border: "1px solid black",
          fontSize: "16px",
          fontWeight: "bold",
          border: "none",
          borderRadius: "8px", 
          cursor: "pointer",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", 
          transition: "transform 0.2s, box-shadow 0.2s", 
        }}
        onMouseOver={(e) => {
          e.target.style.transform = "scale(1.05)";
          e.target.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
        }}
        onMouseOut={(e) => {
          e.target.style.transform = "scale(1)";
          e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
        }}
        onClick={() => handleLogin("redirect")}
      >
        LOGIN
      </Button>
    </div>
  </div>
  
  );
};